<template lang="pug">
  .product-container
    .product-header
      .product-title
        p {{ $t('Data Hub') }}
        p {{ $t('营销数据洞察平台') }}
      .product-desc
        p {{ $t('Data Hub专注于营销全链路监控及数据管理分析，为客户多渠道多维度衡量营销效果表现。') }}
        p {{ $t('联合利华、拜耳、维京游轮通过Data Hub解决6个渠道的效果营销分析与洞察。') }}
      el-button.product-link(
        @click="onApplyAccount"
      ) {{ $t('申请Demo账号') }}
      .product-img
        img(
          src="@/assets/datahub-1.png"
        )
    .product-content-container
      .product-content-item
        .product-content-desc
          .desc-title {{ $t('数据监测') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('精准的数据采集') }}
          .desc {{ $t('支持广告监测，网站监测及小程序监测，结合客户CRM导入的订单、销售数据，从广告曝光到网站再到最后下单，良好的时效性，丰富全面的维度和指标，助力企业形成营销转化闭环。') }}

          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('丰富的可视化报表') }}
          .desc {{ $t('从投放概览到趋势分析，从渠道占比分析到渠道漏斗分析，没有最细只有更细，在线查询图表或自由定制数据报表，一切只为帮助企业更好更便捷的分析数据，分析ROI。') }}
        img(
          src="@/assets/datahub-2.png"
        )
      .product-content-item
        .product-content-desc.product-content-desc__mr
          .desc-title {{ $t('营销漏斗') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('全面的洞察分析') }}
          .desc {{ $t('支持分渠道、分终端自定义配置漏斗，深入分析广告数据、网站数据、转化数据、订单数据。同时支持单个渠道中的分媒体表现分析，渠道媒体转化效果孰优孰劣，一目了然。') }}

          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('极速对接CRM') }}
          .desc {{ $t('成熟的API文档，高效对接企业CRM，打通全链路数据。若企业因为数据敏感，复歌也可以进行私有化部署配置，打造企业专属的第一方数据管理平台。') }}
        img(
          src="@/assets/datahub-3.png"
          )
      .product-content-item
        .product-content-desc
          .desc-title {{ $t('受众分析') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('360°用户画像') }}
          .desc {{ $t('通过复歌的Universal ID针对用户进行统一标识并加密，无论其在PC、移动还是小程序，均可获取其在网站中的用户路径图，再结合第三方数据源丰富用户画像。') }}
        img(
          src="@/assets/datahub-4.png"
        )
    section#clients-say
      div.clients-say__content
        img(
          alt="what our clients say"
          src="@/assets/clients-say-logo.png"
        )
        div
          ul.clients-say__case__content
            li(:class="{'active': activeIndex === 0}")
              p {{ $t('复歌的Data Hub满足了我们对于各类营销渠道投放效果深入分析的诉求，无论是整体营销漏斗、媒体渠道漏斗的数据洞察，还是人群分析功能中的访客路径详情，均很好的为我们提供了各类Leads的有效归因分析，从而针对目标用户进行更精准的重定向营销。') }}
          ul.clients-say__case__avators.f.f-sa
            li(
              :class="{'active_li': activeIndex === 0}"
              @mouseover="activeIndex = 0"
            )
              div
                img(
                  alt="avator"
                  src="@/assets/datahub-avator.png"
                )
              p
                | Ray
                br
                span
                  | 市场部经理/拜耳虫虫拜拜

    contact
</template>

<script>
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    Contact: MobileContact
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  methods: {
    onApplyAccount () {
      this.$router.push('/contact?redirectUrl=/product/data_hub&buttonName=申请Demo账号')
    }
  }
}
</script>
